// removed by extract-text-webpack-plugin
module.exports = {"SortListItem":"or3FriwbCjlWk4qeCBpQ9","checkbox":"_37l4oFb47va6lTiBAGJJ3P","label":"_3iAVgDaHtW790gWSJPk15J","arrowDESC":"_1rYyHM-9m5ypy8t5byQVqK","arrowASC":"gBonKnYxsTmKpiXgCicYj _1rYyHM-9m5ypy8t5byQVqK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SortListItem/SortListItem.css
// module id = 307
// module chunks = 8